import FacebookIcon from '@/assets/icons/social/facebook.svg?react';
import InstagramIcon from '@/assets/icons/social/instagram.svg?react';
import EternaLifeLogo from '@/assets/logos/eterna-life.svg?react';
import { useBreakpoint } from '@/lib/contexts/BreakpointContext';
import { routes } from '@/routes/routes';
import { Link, useLocation } from '@tanstack/react-router';

const socialLinks = [
  // {
  //   to: 'https://open.spotify.com/show/5Z0bX6pX1JtYh3pG7gD5ZV',
  //   Icon: SpotifyIcon,
  // },
  // {
  //   to: 'https://www.instagram.com/eternalifepodcast/',
  //   Icon: PodcastIcon,
  // },
  {
    to: 'https://www.facebook.com/profile.php?id=61577043010704',
    Icon: FacebookIcon,
  },
  {
    to: 'https://www.instagram.com/eternalife_supplements/',
    Icon: InstagramIcon,
  },
  // {
  //   to: 'https://www.instagram.com/eternalife',
  //   Icon: YoutubeIcon,
  // },
];

export const Footer = () => {
  const { isDesktop } = useBreakpoint();
  const location = useLocation();

  const showDisclaimer = /^\/ingredients\/\d+$/.test(location.pathname);

  return (
    <footer className="bg-secondary mt-auto px-4 pt-40 pb-13 lg:px-6 lg:pt-47 lg:pb-20.5">
      <div className="text-secondary-foreground mx-auto flex w-full max-w-305 flex-col items-center gap-13.5 text-center lg:grid lg:grid-cols-6 lg:items-center lg:gap-12.25 lg:text-start lg:[grid-template-areas:'logo_logo_logo_logo_logo_logo''text_text_text_text_nav_nav''privacy_privacy_copyright_copyright_nav_nav'] [&_a]:hover:brightness-90 [&_a]:active:brightness-90">
        <Link to={routes.home} className="col-span-6 lg:[grid-area:logo]">
          <EternaLifeLogo className="h-10 w-51.25" />
        </Link>

        <p className="max-w-98.25 leading-6.5 lg:mb-14 lg:[grid-area:text]">
          Want to speak with an advisor?{' '}
          <Link
            to={routes.help.contactUs}
            className="text-primary hover:text-accent transition-colors"
          >
            Contact us.
          </Link>
        </p>

        <nav className="flex h-full flex-col gap-3.5 text-xl leading-6.5 lg:grid lg:place-self-end lg:self-start lg:leading-6 lg:[grid-area:nav]">
          <div className="flex flex-col items-start gap-3.5">
            <Link to={routes.auth.login}>Pacient login</Link>
            {isDesktop && (
              <Link to={routes.auth.login}>{'Direct line for doctors'}</Link>
            )}
          </div>

          {isDesktop && (
            <nav className="mt-auto flex gap-2.25 self-start">
              {socialLinks.map(({ to, Icon }) => (
                <a key={to} href={to} target="_blank" rel="noopener noreferrer">
                  <Icon className="text-accent lg:text-primary size-8" />
                </a>
              ))}
            </nav>
          )}
        </nav>

        {isDesktop && (
          <>
            <Link
              to={routes.legal.privacyPolicy}
              className="col-span-2 text-lg leading-6.5 lg:[grid-area:privacy]"
            >
              Cookie & Privacy policy
            </Link>
            <p className="col-span-2 text-center text-lg leading-6.5 text-[#E8DFC6] lg:[grid-area:copyright]">
              {new Date().getFullYear()} © Eternalife
            </p>
          </>
        )}

        <nav className="flex justify-end gap-2.25 lg:hidden">
          {socialLinks.map(({ to, Icon }) => (
            <a key={to} href={to} target="_blank" rel="noopener noreferrer">
              <Icon className="text-accent lg:text-primary size-8" />
            </a>
          ))}
        </nav>

        {!isDesktop && (
          <div className="flex flex-col gap-3.25 text-sm leading-4.5">
            <Link to={routes.legal.privacyPolicy}>Cookie & Privacy policy</Link>

            <p className="text-[#E8DFC6]">
              {new Date().getFullYear()} © Eternalife
            </p>
          </div>
        )}
      </div>

      {showDisclaimer && (
        <p className="text-secondary-foreground mx-auto mt-8 w-fit rounded-full border px-2 py-1.5 text-center text-xs">
          * These statements have not been evaluated by the Food and Drug
          Administration. This product is not intended to diagnose, treat, cure
          or prevent any disease.
        </p>
      )}
    </footer>
  );
};
